export interface NavIconProps {
  path: string;
  size?: number;
  className?: string;
}

/** Stroke icon from a single path string (see navItems). */
export default function NavIcon({ path, size = 20, className = '' }: NavIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
      <path d={path} />
    </svg>
  );
}
